// Enhanced navigation behavior for better UX while maintaining accessibility
function enhanceNavigationBehavior() {
  const summaryElements = document.querySelectorAll('.site-nav__details summary[data-link]');
  
  summaryElements.forEach(summary => {
    const url = summary.getAttribute('data-link');
    const details = summary.closest('details');
    
    // Remove the default click behavior prevention for summary elements
    summary.addEventListener('click', function(e) {
      // Check if this was triggered by a mouse click (not keyboard)
      if (e.detail > 0) { // e.detail is 0 for keyboard events, > 0 for mouse clicks
        e.preventDefault();
        
        // Navigate to the URL
        if (url && url !== '#') {
          window.location.href = url;
        }
      }
      // If it's a keyboard event (e.detail === 0), let the default behavior handle it
    });
    
    // Handle keyboard navigation
    summary.addEventListener('keydown', function(e) {
      // Handle Enter and Space keys for dropdown toggle
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        
        // Toggle the details open state
        const isOpen = details.hasAttribute('open');
        
        if (isOpen) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
          
          // Focus the first dropdown link after opening
          setTimeout(() => {
            const firstDropdownLink = details.querySelector('.site-nav__dropdown-link');
            if (firstDropdownLink) {
              firstDropdownLink.focus();
            }
          }, 100);
        }
      }
      
      // Handle Escape key to close dropdown
      else if (e.key === 'Escape') {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          summary.focus(); // Return focus to the summary
        }
      }
    });
    
    // Handle focus management within dropdowns
    const dropdownLinks = details.querySelectorAll('.site-nav__dropdown-link, .site-nav__dropdown a, .megamenu a');
    
    dropdownLinks.forEach((link, index) => {
      link.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          // Close dropdown and return focus to summary
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
        else if (e.key === 'ArrowDown') {
          e.preventDefault();
          const nextLink = dropdownLinks[index + 1];
          if (nextLink) {
            nextLink.focus();
          }
        }
        else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (index === 0) {
            summary.focus();
          } else {
            const prevLink = dropdownLinks[index - 1];
            if (prevLink) {
              prevLink.focus();
            }
          }
        }
      });

      // Handle tab navigation - close dropdown when tabbing out of last item
      link.addEventListener('keydown', function(e) {
        if (e.key === 'Tab' && !e.shiftKey) {
          // Check if this is the last focusable element in this dropdown
          const isLastItem = index === dropdownLinks.length - 1;
          
          if (isLastItem) {
            // Close this dropdown when tabbing away from the last item
            setTimeout(() => {
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
            }, 0);
          }
        }
      });
    });

    // Also handle tab navigation on the summary itself
    summary.addEventListener('keydown', function(e) {
      if (e.key === 'Tab' && !e.shiftKey) {
        // If dropdown is open and user tabs forward from summary, go to first dropdown item
        if (details.hasAttribute('open')) {
          const firstDropdownLink = dropdownLinks[0];
          if (firstDropdownLink) {
            e.preventDefault();
            firstDropdownLink.focus();
          }
        }
      }
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.site-nav__details')) {
      summaryElements.forEach(summary => {
        const details = summary.closest('details');
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
}

// Update your existing hover menu function to work better with the new behavior
function updateHoverMenu() {
  const detailsElements = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
  let currentOpenDetail = null;

  // Function to close a specific dropdown
  function closeDropdown(detail) {
    if (detail && detail.hasAttribute('open')) {
      const summary = detail.querySelector('summary');
      detail.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  // Function to open a dropdown
  function openDropdown(detail) {
    const summary = detail.querySelector('summary');
    if (!detail.hasAttribute('open')) {
      detail.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }
  }

  detailsElements.forEach((detail) => {
    const summary = detail.querySelector('summary');
    const navItem = detail.closest('.site-nav__item');

    // Mouse enter on the nav item (not just the dropdown)
    navItem.addEventListener('mouseenter', () => {
      // Close any previously open dropdown
      if (currentOpenDetail && currentOpenDetail !== detail) {
        closeDropdown(currentOpenDetail);
      }
      
      // Open this dropdown
      openDropdown(detail);
      currentOpenDetail = detail;
    });

    // Don't close on mouse leave if an element inside has focus
    detail.addEventListener('focusout', (e) => {
      // Check if the new focus target is outside this details element
      setTimeout(() => {
        if (!detail.contains(document.activeElement)) {
          closeDropdown(detail);
          if (currentOpenDetail === detail) {
            currentOpenDetail = null;
          }
        }
      }, 0);
    });
  });

  // Close dropdowns when mouse leaves the entire navigation area
  const navigation = document.querySelector('.site-navigation');
  if (navigation) {
    navigation.addEventListener('mouseleave', () => {
      // Only close if no element inside has focus
      setTimeout(() => {
        if (currentOpenDetail && !currentOpenDetail.contains(document.activeElement)) {
          closeDropdown(currentOpenDetail);
          currentOpenDetail = null;
        }
      }, 100); // Small delay to prevent flickering
    });
  }

  // Mutation observer to watch for manual dropdown state changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const detail = mutation.target;
        
        // If a dropdown was opened manually (keyboard/click), track it
        if (detail.hasAttribute('open')) {
          // Close other dropdowns if this one was opened
          detailsElements.forEach((otherDetail) => {
            if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
              closeDropdown(otherDetail);
            }
          });
          currentOpenDetail = detail;
        } else {
          // If this dropdown was closed and it was the current one, clear the reference
          if (currentOpenDetail === detail) {
            currentOpenDetail = null;
          }
        }
      }
    });
  });

  // Observe all navigation dropdowns for attribute changes
  detailsElements.forEach((detail) => {
    observer.observe(detail, {
      attributes: true,
      attributeFilter: ['open']
    });
  });

  // Store observer reference for cleanup
  updateHoverMenu.observer = observer;
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  enhanceNavigationBehavior();
  updateHoverMenu();
});

// Re-initialize when sections are reloaded (for Shopify theme editor)
document.addEventListener('shopify:section:load', function() {
  // Clean up previous observer if it exists
  if (updateHoverMenu.observer) {
    updateHoverMenu.observer.disconnect();
  }
  
  enhanceNavigationBehavior();
  updateHoverMenu();
});

// Clean up observer when page unloads
window.addEventListener('beforeunload', function() {
  if (updateHoverMenu.observer) {
    updateHoverMenu.observer.disconnect();
  }
});